import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../constants/ActionTypes';
import Spinner from './Spinner';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

class ButtonPreview extends Component {
    render() {
        const fontSize = new CSSLength(this.props.data.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const borderRadius = new CSSLength(this.props.data.borderRadius, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        const borderRadius2 = borderRadius.px;
        const borderRadius3 = Math.round(borderRadius2.substring(0, borderRadius2.length - 2)) + 'px';

        return (
            <div className="ButtonPreview">
                <h4>{this.props.tagNameName}</h4>
                <p>{this.props.tag}</p>
                <div className="row">
                    <div className="col-lg-2 col-xs-12 col-sm-6">
                        <div
                            className="add-to-cart-button"
                            style={{
                                background: this.props.data.background.normal,
                                border: this.props.data.border.normal,
                                color: this.props.data.color.normal,
                                //   borderStyle: this.props.buttonPreview.general.style,
                                //   borderWidth: this.props.buttonPreview.general.borderWidth,
                                borderRadius: borderRadius3,
                                fontSize: fontSize3,
                                fontStyle: this.props.data.style,
                                fontWeight: this.props.data.weight,
                                fontFamily: this.props.data.font,
                                textTransform: this.props.data.textTransform
                            }}
                        >
                            <Spinner
                                styles={{
                                    'border-top': '5px solid ' + this.props.data.spinner.color1,
                                    'border-right': '5px solid ' + this.props.data.spinner.color1,
                                    'border-bottom': '5px solid ' + this.props.data.spinner.color1,
                                    'border-left': '5px solid ' + this.props.data.spinner.color2
                                }}
                            />
                            Sample Normal
                            {this.props.data.after ? (
                                <span
                                    style={{
                                        display: 'inline-block',
                                        height: '1500px',
                                        position: 'absolute',
                                        transitionDuration: '100ms',
                                        transitionProperty: 'transform',
                                        transitionTimingFunction: 'cubic-bezier(0.86, 0, 0.07, 1)',
                                        width: '1500px',
                                        zIndex: 1,
                                        background: this.props.data.after.background.normal,
                                        transform: 'translate(-29%, -2%) rotate(-24deg)'
                                    }}
                                >
                                    {' '}
                                </span>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className="col-lg-2 offset-lg-2 col-xs-12 col-sm-6">
                        <div
                            className="add-to-cart-button"
                            style={{
                                background: this.props.data.background.hover,
                                border: this.props.data.border.hover,
                                color: this.props.data.color.hover,
                                // borderStyle: this.props.buttonPreview.general.style,
                                // borderWidth: this.props.buttonPreview.general.borderWidth,
                                borderRadius: borderRadius3,
                                fontSize: fontSize3,
                                fontStyle: this.props.data.style,
                                fontWeight: this.props.data.weight,
                                fontFamily: this.props.data.font,
                                textTransform: this.props.data.textTransform
                            }}
                        >
                            <Spinner
                                styles={{
                                    'border-top': '5px solid ' + this.props.data.spinner.color1,
                                    'border-right': '5px solid ' + this.props.data.spinner.color1,
                                    'border-bottom': '5px solid ' + this.props.data.spinner.color1,
                                    'border-left': '5px solid ' + this.props.data.spinner.color2
                                }}
                            />
                            Sample Hover
                        </div>
                    </div>
                    {this.props.layer === 'primary' && (
                        <div className="col-lg-2 offset-lg-2 col-xs-12 col-sm-6">
                            <div
                                className="add-to-cart-button"
                                style={{
                                    background: this.props.data.background.active,
                                    border: this.props.data.border.active,
                                    color: this.props.data.color.active,
                                    // borderStyle: this.props.buttonPreview.general.style,
                                    // borderWidth: this.props.buttonPreview.general.borderWidth,
                                    borderRadius: borderRadius3,
                                    fontSize: fontSize3,
                                    fontStyle: this.props.data.style,
                                    fontWeight: this.props.data.weight,
                                    fontFamily: this.props.data.font,
                                    textTransform: this.props.data.textTransform
                                }}
                            >
                                <Spinner
                                    styles={{
                                        'border-top': '5px solid ' + this.props.data.spinner.color1,
                                        'border-right': '5px solid ' + this.props.data.spinner.color1,
                                        'border-bottom': '5px solid ' + this.props.data.spinner.color1,
                                        'border-left': '5px solid ' + this.props.data.spinner.color2
                                    }}
                                />
                                Sample Active
                                {this.props.data.after ? (
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            height: '1500px',
                                            position: 'absolute',
                                            transitionDuration: '100ms',
                                            transitionProperty: 'transform',
                                            transitionTimingFunction: 'cubic-bezier(0.86, 0, 0.07, 1)',
                                            width: '1500px',
                                            zIndex: 1,
                                            background: this.props.data.after.background.active,
                                            transform: 'translate(-29%, -2%) rotate(-24deg)'
                                        }}
                                    >
                                        {' '}
                                    </span>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

ButtonPreview.defaultProps = {
    isDisabled: false
};

ButtonPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object,
    tag: PropTypes.string,
    isDisabled: PropTypes.bool
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.button, ...state.theme.button };
};

const mapDispatchToProps = dispatch => {
    return {
        //Generic action that can potentially kill a lot of boiler plate code
        onLeafPropertyChange: (layer, target, leaf) => {
            return event =>
                dispatch({
                    type: ActionTypes.LEAF_PROPERTY_CHANGE,
                    layer: layer,
                    target: target,
                    leaf: leaf,
                    value: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/Preview.js